import { useMemo } from 'react'

import { useLocation } from '@eastcoal/router/exports/react-router'

export const useUrlHash = () => {
  const { hash } = useLocation()
  return useMemo(() => (hash ? hash.replace(/^#/, '') : ''), [hash])
}
